import 'arrive';

// Import Swiper bundle (include tutti i moduli)
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.arrive('.product-related', { existing: true }, function () {
    const relatedSwiper = new Swiper('.product-related-swiper', {
        slidesPerView: 1.15,
        spaceBetween: 8,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            500: {
                slidesPerView: 1.15,
                spaceBetween: 8,
            },
            768: {
                slidesPerView: 2.3,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 24,
            }
        }
    });
});